export default "__VITE_ASSET__C_13KEKS__"